module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"kowitz-kitchen","short_name":"kowitz-kitchen","start_url":"/","background_color":"#ffffff","theme_color":"#333333","display":"minimal-ui","icon":"src/images/favicon.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"a46ef4172f7bda77f06274f61a458172"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
